import { render } from "./SeasonComparisonChart.vue?vue&type=template&id=52c5f9f0&scoped=true"
import script from "./SeasonComparisonChart.vue?vue&type=script&lang=js"
export * from "./SeasonComparisonChart.vue?vue&type=script&lang=js"

import "./SeasonComparisonChart.vue?vue&type=style&index=0&id=52c5f9f0&scoped=true&lang=css"
import "./SeasonComparisonChart.vue?vue&type=style&index=1&id=52c5f9f0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c5f9f0"]])

export default __exports__